import { render, staticRenderFns } from "./SendMessage.vue?vue&type=template&id=e5f6f864"
import script from "./SendMessage.vue?vue&type=script&lang=js"
export * from "./SendMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5f6f864')) {
      api.createRecord('e5f6f864', component.options)
    } else {
      api.reload('e5f6f864', component.options)
    }
    module.hot.accept("./SendMessage.vue?vue&type=template&id=e5f6f864", function () {
      api.rerender('e5f6f864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/SendMessage.vue"
export default component.exports